export default "__VITE_ASSET__JBG5HPIo__"